import { render, staticRenderFns } from "./IlluEconomie.vue?vue&type=template&id=a390951c&"
import script from "./IlluEconomie.vue?vue&type=script&lang=js&"
export * from "./IlluEconomie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports